'use client'
import type { ReactNode } from 'react'
import { useState, useRef, useEffect } from 'react'
import { cx } from '../utils'

export function Tooltip({
  content,
  children,
}: {
  content: string
  children: ReactNode
}) {
  const [show, setShow] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const timeout = useRef<ReturnType<typeof setTimeout>>(undefined)

  const showTooltip = () => {
    timeout.current = setTimeout(() => setShow(true), 400)
  }
  const hideTooltip = () => {
    clearTimeout(timeout.current)
    setShow(false)
  }

  useEffect(() => () => clearTimeout(timeout.current), [])

  return (
    <div ref={ref} className="relative inline-flex" onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
      {children}
      {show && (
        <div
          role="tooltip"
          className={cx(
            'absolute bottom-full left-1/2 z-50 mb-1.5 -translate-x-1/2 rounded-xs',
            'bg-ink px-2 py-1 text-[13px] text-surface whitespace-nowrap shadow-[var(--shadow-md)]',
          )}
        >
          {content}
        </div>
      )}
    </div>
  )
}
